module.exports = __webpack_public_path__ + "img/rurimobile_char.f6f0b076.png";